import { $ } from "@/common/Axios";

export default {
  /**
   * 地址信息
   */
  addressInfo: {
    /*
     * 编辑
     * address 地址 (string query )
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * province 省 (string query )
     * searchStatus 查询状态 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/addressInfo", p, c),
  },
  addressInfo_getByAddress: {
    /*
     * 根据地址获取
     * address address (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/getByAddress", p, c),
  },
  addressInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/list", p, c),
  },

  /**
   * 对账单
   */
  bill_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/bill/export", p, c),
  },
  bill_getSummaryType: {
    /*
     * 获取摘要类型
     */
    get: (p, c) => $.get("/api/bms/extension/bill/getSummaryType", p, c),
  },
  bill_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/bill/list", p, c),
  },
  bill_refresh: {
    /*
     * 刷新
     * date 日期：yyyy-MM-dd (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refresh", p, c),
  },
  bill_refreshByAccount: {
    /*
     * 刷新
     * account 账号 (string query )
     * date 日期：yyyy-MM-dd (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refreshByAccount", p, c),
  },
  bill_setSummaryType: {
    /*
     * 设置摘要类型
     * summaryTypes 摘要类型json字符串 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/setSummaryType", p, c),
  },
  bill_updateType: {
    /*
     * 更新类型类型
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/bill/updateType", p, c),
  },

  /**
   * 列表标签
   */
  columnLabel: {
    /*
     * 添加
     * id  (integer query )
     * name 标签名字 (string query )
     * type 标签类型 (string query )
     * url 标签地址 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/columnLabel", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/columnLabel", p, c),
  },
  columnLabel_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/list", p, c),
  },
  columnLabel_listSimple: {
    /*
     * 简易列表
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listSimple", p, c),
  },
  columnLabel_listType: {
    /*
     * 类型列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listType", p, c),
  },

  /**
   * ding-task-controller
   */
  dingTask_finishTask: {
    /*
     * 完成代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    put: (p, c) => $.put("/api/bms/extension/dingTask/finishTask", p, c),
  },
  dingTask_removeTask: {
    /*
     * 删除代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingTask/removeTask", p, c),
  },
  dingTask_save: {
    /*
     * 新增代办
     * appUrl appUrl (string query )
     * contentId 来源ID (integer query )
     * deadline 截止时间(2022-08-05 23:59:59) (string query )
     * description 代办描述 (string query )
     * pcUrl pcUrl (string query )
     * targetAdminId targetAdminId (integer query )
     * title 代办标题 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingTask/save", p, c),
  },

  /**
   * 钉钉
   */
  dingtalk_addLog: {
    /*
     * 添加日志
     * createId 日志创建人 (integer query required)
     * fieldNames 字段名称 (array query required)
     * fieldValues 字段值 (array query required)
     * groupIds 接受人群id (array query )
     * templateId 日志模板id (string query required)
     * toAdminIds 接受人id (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/addLog", p, c),
  },
  dingtalk_changeScheduleMember: {
    /*
     * 添加或者删除日程参与者
     * adminIds 参与人员 (array query required)
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     * type 类型添加|删除 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/changeScheduleMember", p, c),
  },
  dingtalk_createProcessInstance: {
    /*
     * 发起钉钉审批实例
     * adminId 管理员id (integer query required)
     * approvalUserIds 审批人钉钉id (array query )
     * componentTypes 控件类型 (array query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * names 表单项名字 (array query required)
     * processCode 审批流的唯一码 (string query required)
     * values 表单项值 (array query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/createProcessInstance", p, c),
  },
  dingtalk_createSchedule: {
    /*
     * 创建日程
     * address 地址 (string query required)
     * adminIds 参与人员 (array query required)
     * content 内容 (string query required)
     * createId 创建人员 (integer query required)
     * endTime 结束时间 (string query required)
     * reminderMinutes 多少分钟前提醒 (integer query required)
     * startTime 开始时间 (string query required)
     * title 标题 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/createSchedule", p, c),
  },
  dingtalk_getInstanceResp: {
    /*
     * 获取钉钉审批实例
     * instanceId 审批实例id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalk/getInstanceResp", p, c),
  },
  dingtalk_postRequest: {
    /*
     * 钉钉post请求
     * appName App名称 (string query )
     * keys 请求参数key (array query )
     * url 请求id (string query required)
     * values 请求参数value (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/postRequest", p, c),
  },
  dingtalk_refreshDingAccessToken: {
    /*
     * 刷新钉钉的AccessToken
     * appName App名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/refreshDingAccessToken", p, c),
  },
  dingtalk_removeSchedule: {
    /*
     * 删除日程
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/dingtalk/removeSchedule", p, c),
  },
  dingtalk_sendDingMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * appName 小程序名称 (string query )
     * message 消息 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendDingMessage", p, c),
  },
  dingtalk_sendDingOAMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * appName 小程序名称 (string query )
     * content 内容 (string query required)
     * pcUrl PC端链接 (string query required)
     * title 标题 (string query required)
     * url 钉钉小程序链接 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/sendDingOAMessage", p, c),
  },
  dingtalk_sendGroupFile: {
    /*
     * 发送群文件
     * fileName 文件名 (string query required)
     * fileType 文件类型 (string query required)
     * mediaId 文件id (string query required)
     * openConversationId 群id (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendGroupFile", p, c),
  },
  dingtalk_syncContinueStudent: {
    /*
     * 同步继教院学生
     * appConfigId 钉钉配置id (integer query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalk/syncContinueStudent", p, c),
  },
  dingtalk_syncOrganization: {
    /*
     * 同步部门和账号
     */
    put: (p, c) => $.put("/api/bms/extension/dingtalk/syncOrganization", p, c),
  },
  dingtalk_uploadMedia: {
    /*
     * 上传钉钉文件
     * path 路径 (string query required)
     * type 类型：image|voice|video|file (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/uploadMedia", p, c),
  },

  /**
   * 钉钉配置
   */
  dingtalkConfig: {
    /*
     * 添加
     * agentId 代理id (string query )
     * appKey appKey (string query )
     * appName 小程序名字 (string query )
     * appSecret appSecret (string query )
     * id  (integer query )
     * orgName 组织名称 (string query )
     * type 类型：内部、继教院学生 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalkConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingtalkConfig", p, c),
  },
  dingtalkConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalkConfig/list", p, c),
  },
  dingtalkConfig_listSimpleForContinue: {
    /*
     * 获取所有继教院钉钉配置
     */
    get: (p, c) =>
      $.get("/api/bms/extension/dingtalkConfig/listSimpleForContinue", p, c),
  },
  dingtalkConfig_refreshAttendance: {
    /*
     * 刷新考勤数据
     * attendanceId 考勤id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/refreshAttendance", p, c),
  },
  dingtalkConfig_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/refreshCache", p, c),
  },
  dingtalkConfig_syncContinueStudent: {
    /*
     * 同步继教院学生（所有）
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/syncContinueStudent", p, c),
  },

  /**
   * 快递查询
   */
  expressInfo_callback: {
    /*
     * 接收回调
     * param param (string query required)
     * sign sign (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/callback", p, c),
  },
  expressInfo_exportCompany: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/exportCompany", p, c),
  },
  expressInfo_listCompany: {
    /*
     * 列表-基础平台-扩展管理-快递公司配置
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/listCompany", p, c),
  },
  expressInfo_query: {
    /*
     * 查询快递信息
     * companyName 快递公司名称 (string query required)
     * expressNo 快递单号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/query", p, c),
  },
  expressInfo_save: {
    /*
     * 添加编辑
     * code 编码 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/save", p, c),
  },
  expressInfo_subscribe: {
    /*
     * 订阅回调-测试
     * companyName 快递公司名称 (string query required)
     * expressNo 快递单号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/subscribe", p, c),
  },
  expressInfo_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/upload", p, c),
  },

  /**
   * 文件导入导出
   */
  fileUploadExport_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/fileUploadExport/list", p, c),
  },
  fileUploadExport_saveUpload: {
    /*
     * 添加导入
     * adminId 管理员id (integer query )
     * exportType 导出类型：实时导出、延时导出 (string query )
     * fileUrl 文件地址 (string query )
     * id  (integer query )
     * requestParams 请求参数 (string query )
     * requestPath 请求路径 (string query )
     * type 类型：导入、导出 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/fileUploadExport/saveUpload", p, c),
  },

  /**
   * 汇付付款人信息
   */
  huifuPayer_getPayerId: {
    /*
     * 获取付款人id
     * name 姓名 (string query required)
     * payAccount 收款账号 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/huifuPayer/getPayerId", p, c),
  },

  /**
   * id关联表
   */
  idAssociation_listContentId: {
    /*
     * 通过类型和关联字段获取内容id
     * associationId 关联id (integer query required)
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/idAssociation/listContentId", p, c),
  },
  idAssociation_setContentId: {
    /*
     * 设置内容id
     * associationId 关联id (integer query required)
     * contentIds 内容id (array query required)
     * type 类型 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/idAssociation/setContentId", p, c),
  },

  /**
   * 安心付周期卡核销订单
   */
  merchantCardDeductionOrder_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/export", p, c),
  },
  merchantCardDeductionOrder_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/list", p, c),
  },
  merchantCardDeductionOrder_listByCardId: {
    /*
     * 根据售卖订单id获取核销订单列表
     * cardId 售卖订单id (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/listByCardId", p, c),
  },
  merchantCardDeductionOrder_sync: {
    /*
     * 根据售卖订单id同步
     * cardOrderId 售卖订单id (integer query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardDeductionOrder/sync", p, c),
  },

  /**
   * 安心付周期卡售卖订单
   */
  merchantCardOrder_bind: {
    /*
     * 绑定
     * feeType 收费单类型 (string query )
     * orderId 业务单ID (string query required)
     * schoolRollId 合同id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/bind", p, c),
  },
  merchantCardOrder_close: {
    /*
     * 关闭安心付周期卡订单
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/close", p, c),
  },
  merchantCardOrder_create: {
    /*
     * 创建
     * cardTemplateId 安心付卡模板ID (string query required)
     * feeType 收费单类型 (string query )
     * msgAppId 小程序id (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardOrder/create", p, c),
  },
  merchantCardOrder_detailsByOutOrderNo: {
    /*
     * 根据outOrderNo查询订单详情
     * outOrderNo outOrderNo (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/detailsByOutOrderNo", p, c),
  },
  merchantCardOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/export", p, c),
  },
  merchantCardOrder_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/list", p, c),
  },
  merchantCardOrder_listSimple: {
    /*
     * 简易列表
     * feeType 收费单类型 (string query )
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/listSimple", p, c),
  },
  merchantCardOrder_sync: {
    /*
     * 同步订单
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/sync", p, c),
  },

  /**
   * 安心付周期卡
   */
  merchantCardTemplate: {
    /*
     * 添加
     * cardPropertyId 客一价协议ID (string query )
     * cardTemplateId 卡id (string query )
     * cardTemplateName 卡模板名称 (string query )
     * cardTemplateStatus 卡状态 (string query )
     * cycleValue 周期计费参数 (string query )
     * hotline 客服电话 (string query )
     * id  (integer query )
     * msgAppId 小程序id (string query )
     * outCardId 外部卡id (string query )
     * price 价格 (number query )
     * rejectReason 驳回原因 (string query )
     * salableEndTime 售卖结束时间 (string query )
     * salableStartTime 售卖开始时间 (string query )
     * usableCount 期数 (integer query )
     * usableShopId 可用门店id (string query )
     * useInstruction 使用说明 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardTemplate", p, c),
  },
  merchantCardTemplate_createCardInfoBySchoolRollId: {
    /*
     * 根据合同id创建安心付周期卡
     * feeType 收费单类型 (string query )
     * liveTime 有效期(小时) (integer query required)
     * peroids 安心付期数 (array query required)
     * schoolRollId 合同id (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/extension/merchantCardTemplate/createCardInfoBySchoolRollId",
        p,
        c
      ),
  },
  merchantCardTemplate_getCardInfoBySchoolRollId: {
    /*
     * 根据合同id获取周期卡信息
     * feeType 收费单类型 (string query )
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/extension/merchantCardTemplate/getCardInfoBySchoolRollId",
        p,
        c
      ),
  },
  merchantCardTemplate_getContSelfPreFee: {
    /*
     * 获取职教自考生预交费用
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getContSelfPreFee", p, c),
  },
  merchantCardTemplate_getPeriod: {
    /*
     * 获取安心付期数
     * batch 批次 (string query required)
     * siteType 学校类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getPeriod", p, c),
  },
  merchantCardTemplate_getPeriodConfig: {
    /*
     * 获取安心付期数配置
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getPeriodConfig", p, c),
  },
  merchantCardTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardTemplate/list", p, c),
  },
  merchantCardTemplate_modifyStatus: {
    /*
     * 上下架
     * id 周期卡id (integer query )
     * operateStatus 状态：发布、下架 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardTemplate/modifyStatus", p, c),
  },
  merchantCardTemplate_setContSelfPreFee: {
    /*
     * 设置职教自考生预交费用
     * fee 预交费用 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/merchantCardTemplate/setContSelfPreFee", p, c),
  },
  merchantCardTemplate_setPeriodConfig: {
    /*
     * 设置安心付期数配置
     * config config (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/merchantCardTemplate/setPeriodConfig", p, c),
  },
  merchantCardTemplate_sync: {
    /*
     * 根据小程序id同步
     * msgAppId 小程序id (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardTemplate/sync", p, c),
  },

  /**
   * 门店
   */
  merchantShop: {
    /*
     * 添加
     * id  (integer query )
     * msgAppId 小程序id (string query )
     * shopId 门店id (string query )
     * shopName 门店名字 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/merchantShop", p, c),
  },
  merchantShop_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/list", p, c),
  },
  merchantShop_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/listSimple", p, c),
  },

  /**
   * 扩展（其他）
   */
  other_broadcastContinueEnroll: {
    /*
     * 继教院|服务部业绩汇报-上传图片服务器临时发送到群
     * remoteUrl 七牛url (string query )
     * token 播报群token (string query )
     * type 类型：继教院|服务部|成教学习规划部|中军驻点线索 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/broadcastContinueEnroll", p, c),
  },
  other_downloadEnrollLetter: {
    /*
     * 下载录取贺函
     * level 层次 (string query required)
     * major 专业 (string query required)
     * name 姓名 (string query required)
     * site 学校 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadEnrollLetter", p, c),
  },
  other_downloadServerFile: {
    /*
     * 下载服务器文件
     * filePath 文件路径 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadServerFile", p, c),
  },
  other_getAlipayBillUrl: {
    /*
     * 支付宝对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getAlipayBillUrl", p, c),
  },
  other_getCache: {
    /*
     * 根据类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCache", p, c),
  },
  other_getCacheByAdmin: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByAdmin", p, c),
  },
  other_getCacheByToken: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByToken", p, c),
  },
  other_getFileMd5String: {
    /*
     * 查询文件MD5
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String", p, c),
  },
  other_getFileMd5String1: {
    /*
     * 查询文件MD5
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String1", p, c),
  },
  other_getMonthPerformance: {
    /*
     * 获取当月业绩
     * dingId 钉钉id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getMonthPerformance", p, c),
  },
  other_getPreAdminIdTest: {
    /*
     * 查询PreAdminId
     */
    get: (p, c) => $.get("/api/bms/extension/other/getPreAdminIdTest", p, c),
  },
  other_getPreDepartmentIdsTest: {
    /*
     * 查询PreDepartmentIds
     */
    get: (p, c) =>
      $.get("/api/bms/extension/other/getPreDepartmentIdsTest", p, c),
  },
  other_getRedis: {
    /*
     * 获取redis缓存
     * key key (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getRedis", p, c),
  },
  other_getResourceByMd5: {
    /*
     * 根据MD5查询资源
     * md5String md5 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getResourceByMd5", p, c),
  },
  other_getResourceUrlById: {
    /*
     * 根据id查询资源Url
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getResourceUrlById", p, c),
  },
  other_getUpToken: {
    /*
     * 获取上传凭证
     * ext 文件扩展名 (string query required)
     * name 文件名 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/getUpToken", p, c),
  },
  other_getWechatBill: {
    /*
     * 微信对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getWechatBill", p, c),
  },
  other_highRisk: {
    /*
     * 校验高危操作
     */
    get: (p, c) => $.get("/api/bms/extension/other/highRisk", p, c),
  },
  other_htmlToImage: {
    /*
     * html转图片
     * url 地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/htmlToImage", p, c),
  },
  other_incrementRedis: {
    /*
     * 根据key获取值并自增
     * adminId 管理员id (string query required)
     * title 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/incrementRedis", p, c),
  },
  other_initRedis: {
    /*
     * 根据key初始化值
     * adminId 管理员id (string query required)
     * title 类型 (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/other/initRedis", p, c),
  },
  other_listCardOrder: {
    /*
     * 获取安心付订单信息
     * end 结束时间 (string query )
     * payAccount 收款账号 (string query required)
     * shopId 门店 (string query required)
     * start 开始时间 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/listCardOrder", p, c),
  },
  other_parseIdCard: {
    /*
     * 解析身份证
     * cardSide 正面(front)｜反面(back) (string query required)
     * url 图片地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseIdCard", p, c),
  },
  other_parseImg: {
    /*
     * 解析图片
     * url 图片地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseImg", p, c),
  },
  other_parsePdf: {
    /*
     * 解析pdf
     * pdfFile pdfFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parsePdf", p, c),
  },
  other_parseQrCode: {
    /*
     * 二维码解析
     * imageUrl 二维码图片地址 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/parseQrCode", p, c),
  },
  other_parseWord: {
    /*
     * 解析word（纯文本）
     * wordFile wordFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWord", p, c),
  },
  other_parseWordTable: {
    /*
     * 解析word表格（多个表格以列表形式返回）
     * cellSplit 单元格分隔符 (string query required)
     * rowSplit 行分隔符 (string query required)
     * wordFile wordFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWordTable", p, c),
  },
  other_pay: {
    /*
     * 付款
     * amount 金额 (number query required)
     * payAccount 收款账号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/pay", p, c),
  },
  other_putCache: {
    /*
     * 根据类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCache", p, c),
  },
  other_putCacheByAdmin: {
    /*
     * 根据登录信息和类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByAdmin", p, c),
  },
  other_putCacheByToken: {
    /*
     * 根据token和类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByToken", p, c),
  },
  other_removeCache: {
    /*
     * 根据类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/other/removeCache", p, c),
  },
  other_removeCacheByAdmin: {
    /*
     * 根据登录信息和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByAdmin", p, c),
  },
  other_removeCacheByToken: {
    /*
     * 根据token和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByToken", p, c),
  },
  other_restoreRedisConfig: {
    /*
     * 恢复redis配置
     * key key (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/restoreRedisConfig", p, c),
  },
  other_saveResource: {
    /*
     * 添加资源
     * cloudUrl 七牛地址 (string query required)
     * fileName 文件名 (string query required)
     * md5String md5 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/saveResource", p, c),
  },
  other_searchOrderInfo: {
    /*
     * 查询订单信息
     * orderNo 订单号 (string query )
     * payAccount 收款账号 (string query )
     * payAccountIdentity 收款账号 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchOrderInfo", p, c),
  },
  other_searchTransferResp: {
    /*
     * 查询转账状态
     * outBizNo 订单号 (string query required)
     * payAccount 打款账号：公司支付宝 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchTransferResp", p, c),
  },
  other_sendDingTalkMassMessage: {
    /*
     * 发送钉钉消息-所有启用的管理员
     * message 消息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/sendDingTalkMassMessage", p, c),
  },
  other_sendDingTalkMessage: {
    /*
     * 发送钉钉消息
     * adminId 管理员id (integer query required)
     * message 消息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/sendDingTalkMessage", p, c),
  },
  other_testArmyStudentBroadcastPerson: {
    /*
     * 中军学生创建播报
     * adminId 管理员id (integer query required)
     * area 线索-区 (string query required)
     * city 线索-市 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/testArmyStudentBroadcastPerson", p, c),
  },
  other_testBroadcastPerson: {
    /*
     * 测试个人业绩播报
     * adminId 管理员id（招生老师） (integer query )
     * amountInfo 金额信息 (string query )
     * area 地区 (string query )
     * clueActivateName 线索提供人名称 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query )
     * subType 子类型 (string query )
     * type 类型 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/testBroadcastPerson", p, c),
  },
  other_timestamp: {
    /*
     * 服务器时间戳
     */
    get: (p, c) => $.get("/api/bms/extension/other/timestamp", p, c),
  },
  other_uploadFileToServer: {
    /*
     * 上传文件到服务器
     * file file (file formData required)
     * subDirectory 保存文件子路径名字 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/other/uploadFileToServer", p, c),
  },
  other_uploadImageBase64ToServer: {
    /*
     * 上传图片base64到服务器
     * base64 base64 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServer", p, c),
  },
  other_uploadImageBase64ToServerLocal: {
    /*
     * 上传图片base64到服务器，不传7牛
     * base64 base64 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServerLocal", p, c),
  },
  other_uploadImageByteToServer: {
    /*
     * 上传图片byte到七牛
     * data 图片byte[] (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageByteToServer", p, c),
  },

  /**
   * 支付配置
   */
  payConfig: {
    /*
     * 添加
     * apiKey 接口秘钥 (string query )
     * companyBody 公司主体 (string query )
     * extraContent 额外信息（JSON字符串） (string query )
     * id  (integer query )
     * mchId 商户ID (string query )
     * mchPublicKey 商户公钥（支付宝使用） (string query )
     * mchSecret 商户密钥 (string query )
     * mchSn 证书序列号 (string query )
     * notifyUrl 通知地址 (string query )
     * payAccount 收款账号 (string query )
     * payAccountIdentity 收款账号标识 (string query )
     * payType 类型：支付宝，微信 (string query )
     * payWay 支付方式 (string query )
     * platform 平台（微信用） (string query )
     * testNotifyUrl 测试环境通知地址 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/payConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/payConfig", p, c),
  },
  payConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/list", p, c),
  },
  payConfig_listAccountByType: {
    /*
     * 根据类型获取账号列表
     * type 类型：支付宝、微信、汇付 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/payConfig/listAccountByType", p, c),
  },
  payConfig_listSimple: {
    /*
     * 简易列表，id为商户id
     * type 类型：支付宝、微信、支付宝小程序、汇付 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/listSimple", p, c),
  },

  /**
   * 行政区域
   */
  region: {
    /*
     * 添加
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * province 省 (string query )
     * streets 街道 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/region", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/region", p, c),
  },
  region_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/region/export", p, c),
  },
  region_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/region/list", p, c),
  },
  region_listCity: {
    /*
     * 查询城市列表
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listCity", p, c),
  },
  region_listDistrict: {
    /*
     * 查询区县列表
     * city 城市 (string query required)
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listDistrict", p, c),
  },
  region_listProvince: {
    /*
     * 查询省份列表
     */
    get: (p, c) => $.get("/api/bms/extension/region/listProvince", p, c),
  },
  region_listStreet: {
    /*
     * 查询街道列表
     * city 城市 (string query required)
     * district 区县 (string query required)
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listStreet", p, c),
  },
  region_setStreet: {
    /*
     * 设置街道
     * city 城市 (string query required)
     * district 区县 (string query required)
     * province 省份 (string query required)
     * streets 街道 (array query required)
     */
    put: (p, c) => $.put("/api/bms/extension/region/setStreet", p, c),
  },
  region_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/region/upload", p, c),
  },

  /**
   * 模板文件
   */
  templateFile: {
    /*
     * 添加
     * fileUrl 文件地址 (string query )
     * hashCode 文件hash (string query )
     * id  (integer query )
     * name 模板名称 (string query )
     * platform 平台 (string query )
     * remark 备注 (string query )
     * renderConfig 渲染配置 (string query )
     * siteId 学校id (integer query )
     * siteType 学校类型 (string query )
     * subType 子类 (string query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/templateFile", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/templateFile", p, c),
  },
  templateFile_details: {
    /*
     * 添加
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/details", p, c),
  },
  templateFile_getFileUrl: {
    /*
     * 获取文件地址
     * siteId 学校id (integer query )
     * siteType 学校类型 (string query required)
     * subType 子类型 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/getFileUrl", p, c),
  },
  templateFile_listAdult: {
    /*
     * 模板文件列表（学历教育）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listAdult", p, c),
  },
  templateFile_listArmySkill: {
    /*
     * 模板文件列表（中军职达）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listArmySkill", p, c),
  },
  templateFile_listContinue: {
    /*
     * 模板文件列表（继续教育）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listContinue", p, c),
  },
  templateFile_listExemptionDegree: {
    /*
     * 模板文件列表（免试专升本）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listExemptionDegree", p, c),
  },
  templateFile_listName: {
    /*
     * 模板名称列表
     * platform 平台 (string query required)
     * subType 子类型 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listName", p, c),
  },
  templateFile_listSelfTaught: {
    /*
     * 模板文件列表（自考平台）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listSelfTaught", p, c),
  },
  templateFile_listSkillTrain: {
    /*
     * 模板文件列表（技能培训）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listSkillTrain", p, c),
  },
  templateFile_listSubType: {
    /*
     * 模板子类型列表
     * platform 平台 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listSubType", p, c),
  },
  templateFile_listType: {
    /*
     * 模板类型列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listType", p, c),
  },
  templateFile_renderDocToPdf: {
    /*
     * 渲染Word模板
     * name 模板名称 (string query required)
     * platform 平台 (string query required)
     * schoolRollId 合同id (integer query required)
     * signImage 签名图片 (string query )
     * signImageKey 签名图片key (string query )
     * targetFileType 目标文件类型：docx，pdf (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/templateFile/renderDocToPdf", p, c),
  },

  /**
   * 微信
   */
  wechat_checkOpenId: {
    /*
     * 检查openId
     * platform 平台 (string query required)
     * type 类型：小程序，公众号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/checkOpenId", p, c),
  },
  wechat_customer_assign: {
    /*
     * 在职分配-测试
     * externalUserId 学生企微ID (string query required)
     * handoverUserId 原负责人企微ID (string query required)
     * msg 转移成功后发给客户的消息，最多200个字符，不填使用默认文案 (string query )
     * newHeaderTeacherId 接收班主任ID (integer query required)
     * originHeaderTeacherId 原班主任ID (integer query required)
     * schoolRollId 合同编号 (integer query required)
     * takeoverUserId 接收人企微ID (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/assign", p, c),
  },
  wechat_customer_exportAssignRecord: {
    /*
     * 导出企微分配记录
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/exportAssignRecord", p, c),
  },
  wechat_customer_listAssignRecord: {
    /*
     * 企微分配记录
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listAssignRecord", p, c),
  },
  wechat_customer_listEmployee: {
    /*
     * 企微员工
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listEmployee", p, c),
  },
  wechat_customer_listSimpleAdmin: {
    /*
     * 简易企微员工列表
     * appName App名称，企微业务助手或中军 (string query required)
     * followUserFlag 是否开通了联系客户功能 (string query )
     * saveRecordFlag 员工是否开启会话存档 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listSimpleAdmin", p, c),
  },
  wechat_customer_listStudent: {
    /*
     * 企微学生
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listStudent", p, c),
  },
  wechat_customer_reAssign: {
    /*
     * 重新分配, 状态为未知或发起失败可
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/reAssign", p, c),
  },
  wechat_customer_syncStatus: {
    /*
     * 查询分配结果
     * handoverUserId 原负责人企微ID (string query required)
     * takeoverUserId 接收人企微ID  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/wechat/customer/syncStatus", p, c),
  },
  wechat_decryptMiniProgram: {
    /*
     * 小程序数据解密,解密后数据自动处理
     * encryptedData 加密数据 (string query required)
     * iv iv (string query required)
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/decryptMiniProgram", p, c),
  },
  wechat_fastReply_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/fastReply/list", p, c),
  },
  wechat_fastReply_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/fastReply/listSimple", p, c),
  },
  wechat_fastReply_save: {
    /*
     * 添加
     * content  (string query )
     * id  (integer query )
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/fastReply/save", p, c),
  },
  wechat_getAccessToken: {
    /*
     * 获取AccessToken
     * category 分类 (string query )
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getAccessToken", p, c),
  },
  wechat_getRequest: {
    /*
     * 微信get请求
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getRequest", p, c),
  },
  wechat_getSignature: {
    /*
     * 获取签名
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getSignature", p, c),
  },
  wechat_listTemplate: {
    /*
     * 获取消息模版
     * category 类型 (string query required)
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/listTemplate", p, c),
  },
  wechat_postRequest: {
    /*
     * 微信post请求
     * body 请求体 (string query required)
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/postRequest", p, c),
  },

  /**
   * 微信配置
   */
  wechatConfig: {
    /*
     * 添加
     * accountAppId 公众号应用ID (string query )
     * accountSecret 公众号密钥 (string query )
     * appAppId APP应用ID (string query )
     * appSecret APP密钥 (string query )
     * id  (integer query )
     * mpAppId 小程序应用ID (string query )
     * mpSecret 小程序密钥 (string query )
     * platform 平台名称 (string query )
     * platformIdentity 平台标识 (string query )
     * welcome 欢迎词 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wechatConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/wechatConfig", p, c),
  },
  wechatConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/list", p, c),
  },
  wechatConfig_listPlatform: {
    /*
     * 平台列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/listPlatform", p, c),
  },
  wechatConfig_refresh: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/extension/wechatConfig/refresh", p, c),
  },

  /**
   * 微信消息
   */
  wechatMessage_sendAccountMessage: {
    /*
     * 发送公众号模板消息
     * keys 变量key (array query required)
     * mpUrl 小程序地址 (string query required)
     * platform 平台 (string query required)
     * userIds 用户id (array query required)
     * values 变量value (array query required)
     * wechatTmplId 微信模板id (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/wechatMessage/sendAccountMessage", p, c),
  },
  wechatMessage_sendAccountMessageByMajorAndRollGrade: {
    /*
     * 根据专业和学籍年级发送公众号模板消息
     * keys 变量key (array query required)
     * majorId 专业id (integer query required)
     * mpUrl 小程序地址 (string query required)
     * platform 平台 (string query required)
     * rollGrade 学籍年级 (string query required)
     * values 变量value (array query required)
     * wechatTmplId 微信模板id (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/extension/wechatMessage/sendAccountMessageByMajorAndRollGrade",
        p,
        c
      ),
  },

  /**
   * 微信模板
   */
  wechatTemplate_getKeywords: {
    /*
     * 获取关键词
     * templateId 微信模板id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/getKeywords", p, c),
  },
  wechatTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/list", p, c),
  },
  wechatTemplate_listSimple: {
    /*
     * 简易列表
     * category 分类:小程序|公众号 (string query )
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/listSimple", p, c),
  },
  wechatTemplate_listSimpleByTmplIds: {
    /*
     * 简易列表
     * templateIds 微信模板id (array query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechatTemplate/listSimpleByTmplIds", p, c),
  },
  wechatTemplate_listTitle: {
    /*
     * 标题列表
     * category 分类:小程序|公众号 (string query )
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/listTitle", p, c),
  },
  wechatTemplate_listTitleContent: {
    /*
     * 根据平台查询简单模板列表
     * category 分类:小程序|公众号 (string query )
     * platform 平台 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechatTemplate/listTitleContent", p, c),
  },
  wechatTemplate_refresh: {
    /*
     * 刷新
     * category 分类:小程序|公众号 (string query required)
     * platform 平台 (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/wechatTemplate/refresh", p, c),
  },

  /**
   * 企业微信
   */
  wecom_callback: {
    /*
     * callback
     * echostr echostr (undefined body )
     * msg_signature msg_signature (string query )
     * nonce nonce (string query )
     * timestamp timestamp (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/callback", p, c),
  },
  wecom_getInfoByCode: {
    /*
     * 使用code获取登录信息，返回40029说明code过期
     * appName App名称，企微业务助手 (string query required)
     * code 登录时获取的 code (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getInfoByCode", p, c),
  },
  wecom_getInfoByUserId: {
    /*
     * 根据qwUserId查询
     * appName App名称，企微业务助手 (string query required)
     * qwUserId qwUserId (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getInfoByUserId", p, c),
  },
  wecom_getStudentList: {
    /*
     * 取外部客户列表，仅查询ID
     * appName App名称，企微业务助手or中军 (string query required)
     * qwUserId 班主任企微userId (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/getStudentList", p, c),
  },
  wecom_getUserIdByPhone: {
    /*
     * getUserIdByPhone
     * phone phone (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getUserIdByPhone", p, c),
  },
  wecom_getWeComConfig: {
    /*
     * 获取签名
     * agentFlag 获取应用的JsApiTicket传1，企业的传0 (integer query required)
     * appName App名称，企微业务助手 (string query required)
     * url 网页的URL， 不包含#及其后面部分 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getWeComConfig", p, c),
  },
  wecom_pullRecord: {
    /*
     * 拉取聊天记录
     * limit 每次取多少条 (integer query )
     * pageSize 取多少次 (integer query )
     * syncAdmin 先同步会话存档的班主任，0为否，其他默认是 (integer query )
     * syncContact 拉取完是否同步服务联系记录，0为否，其他默认是 (integer query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/pullRecord", p, c),
  },
  wecom_refreshAccessToken: {
    /*
     * 刷新企微的AccessToken
     * appName App名称，企微业务助手 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/refreshAccessToken", p, c),
  },
  wecom_syncContactRecord: {
    /*
     * 同步企微联系记录
     * endTime endTime (string query )
     * qwUserId qwUserId (string query )
     * startTime startTime (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncContactRecord", p, c),
  },
  wecom_syncFollowUserList: {
    /*
     * 获取配置了客户联系功能的成员列表
     * appName App名称，企微业务助手 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/syncFollowUserList", p, c),
  },
  wecom_syncPermitUserList: {
    /*
     * 查询已开通会话存档的班主任企微userId列表
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncPermitUserList", p, c),
  },
  wecom_syncUserAndCustomer: {
    /*
     * 同步企微员工，并且拉取学生列表，学生详情等
     * appName App名称，企微业务助手or中军 (string query required)
     * getStudent 是否同时拉取外部学生列表 (boolean query required)
     * getStudentDetail 是否同时拉取外部学生详情 (boolean query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/wecom/syncUserAndCustomer", p, c),
  },
  wecom_syncUserList: {
    /*
     * 同步通讯录成员
     * appName App名称，中军企微通讯录同步或企微通讯录同步 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncUserList", p, c),
  },
};
